import React, { useEffect, useRef } from 'react';
import InfoViewText from '../components/InfoViewText/InfoViewText';
import BackLink from '../components/BackLink/BackLink';
import { useAppContext } from '../core/context';
import Timeout from '../components/Timeout/Timeout';
import InfoWrapper from '../components/InfoWrapper/InfoWrapper';
import { useLanguageContext } from '../core/locale/LanguageContext';
import { viewEvents } from '../core/services/mixpanelEvents';
import IceCream from '../lib/assets/ice-cream.svg';
import { useFlag } from '../feature-flags';

function TimeoutView(): React.ReactNode {
  const context = useAppContext();
  const showNewDesign = useFlag('redesign');
  const viewLoadedRef = useRef(false);

  useEffect(() => {
    if (context.claims && !viewLoadedRef.current) {
      viewLoadedRef.current = true;
      context.mixpanel?.trackViewLoad(viewEvents.LANDING_PAGE_TIMEOUT_VIEWED, {
        'Expires At': context.claims.expiryTime,
        'Issued At': context.claims.issuedAt,
      });
    }
  }, [context]);
  const languageContext = useLanguageContext();

  if (showNewDesign) {
    return (
      <>
        <div className="timeout-view-illustration-wrapper">
          <img
            src={IceCream}
            alt=""
            className="timeout-view-illustration-image"
            aria-hidden="true"
          />
          <BackLink reason="TIMEOUT">{languageContext.getLocalizedText('timeoutPrimary')}</BackLink>
        </div>
        <div className="timeout-view-header">
          <h1 className="timeout-view-heading">
            {languageContext.getLocalizedText('timeoutHeader')}
          </h1>
          <p className="timeout-view-description">
            {languageContext.getLocalizedText('timeoutContent').split('\n')}
          </p>
        </div>
      </>
    );
  }

  return (
    <InfoWrapper>
      <InfoViewText
        icon={<Timeout />}
        title={languageContext.getLocalizedText('timeoutHeader')}
        lines={languageContext.getLocalizedText('timeoutContent').split('\n')}
        bold={true}
      />
      <BackLink reason="TIMEOUT">{languageContext.getLocalizedText('timeoutPrimary')}</BackLink>
    </InfoWrapper>
  );
}

export default TimeoutView;
